import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getAsianFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does Asian food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: `What kinds of Asian cuisine can food ${vehicleType}s serve at events?`,
    answer: `Korean BBQ, Japanese ramen and sushi, Thai curries, Vietnamese pho and banh mi, Chinese stir-fries, dumplings, poke bowls, and fusion menus. Most ${vehicleType}s focus on one cuisine, so check each public profile for what it serves.`
  },
  {
    question: `Are Asian food ${vehicleType}s a good fit for corporate events and office catering?`,
    answer: `Yes. Bowls and handhelds come together fast, travel well, and adapt easily for dietary needs. Ask each ${vehicleType} how many guests it can serve per hour and whether it can set up indoors if you need it to.`
  },
  {
    question: `Can Asian food ${vehicleType}s handle vegetarian, vegan, or gluten-free requests?`,
    answer: `Many offer vegetarian, vegan, and gluten-free versions, and some offer halal. Note dietary needs in your request so the ${vehicleType}s that quote can plan for them.`
  },
  {
    question: `How far in advance should I book an Asian food ${vehicleType} for catering?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  }
];

function AsianFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getAsianFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default AsianFaq;
